import { useEditableMissionState } from '../../missions/model/useEditableMissionState.tsx';
import { usePageView } from '../../support/tracking/usePageView.tsx';
import { MissionNotes } from './MissionNotes.tsx';

export const MissionNotesPage: React.FC<{ missionId: string }> = ({ missionId }) => {
    usePageView('Mission Notes');

    const vm = useEditableMissionState(missionId);

    if (!vm) {
        return null;
    }

    return (
        <MissionNotes mission={vm} />
    );
};
